import { useState } from "react";

import { Grid, TextField } from "@mui/material";

import { DrawerForm, DrawerFormSection } from "../../../../components/DrawerForm";
import { FormHiddenField, IconAutocomplete } from "../../../../components/forms";
import { DRAWER_FORM_GRID_SPACING, drawerReadonlyFieldSx } from "../../../../lib/ui/dialogFormLayout";
import { ASSIGNMENT_TYPE_OPTIONS } from "../../../../lib/ui/iconSelectOptions";
import { useTranslation } from "react-i18next";

const AssignIncidentBody = (item: any) => {
  const { t } = useTranslation();
  const [selectedAssignmentType, setSelectedAssignmentType] = useState<string | null>("user");

  return (
    <DrawerForm>
      <DrawerFormSection title={t("form.incident")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField
              fullWidth
              id="incidentId"
              name="incidentId"
              label={t("common.id")}
              variant="outlined"
              size="small"
              value={item?.id || ""}
              InputProps={{ readOnly: true }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              id="incidentTitle"
              name="incidentTitle"
              label={t("common.title")}
              variant="outlined"
              size="small"
              value={item?.title || ""}
              InputProps={{ readOnly: true }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>

      <DrawerFormSection title={t("form.assignment")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <IconAutocomplete
              options={ASSIGNMENT_TYPE_OPTIONS}
              value={selectedAssignmentType}
              onChange={setSelectedAssignmentType}
              label={t("incidents.assignTo")}
              noOptionsText="No assignment type options found"
            />
            <FormHiddenField name="assignmentType" value={selectedAssignmentType || ""} />
          </Grid>
          {selectedAssignmentType === "group" ? (
            <Grid size={12}>
              <TextField
                fullWidth
                id="assignedGroup"
                name="assignedGroup"
                label={t("incidents.groupName")}
                variant="outlined"
                size="small"
                required
                placeholder={t("form.groupName")}
              />
            </Grid>
          ) : null}
        </Grid>
      </DrawerFormSection>
    </DrawerForm>
  );
};

export default AssignIncidentBody;
